import { ViewerSearchQuery } from "./dto/ViewerSearchQuery";
import { ViewerSearchQueryResult } from "./dto/ViewerSearchQueryResult";
import { UpdateViewerLocationCollapseStateCommand } from "./dto/UpdateViewerLocationCollapseStateCommand";
import { DismissViewerNewsItemCommand } from "./dto/DismissViewerNewsItemCommand";

// Whitelist erlaubter Backend-Hosts
const ALLOWED_BASE_PATH_PREFIXES = [
    '/portal',
];

const validateBaseUrl = (baseUrl: string): void => {
    // Eingabe prüfen
    if (!baseUrl || typeof baseUrl !== 'string') {
        throw new Error('Invalid base URL');
    }
    // Kein URL-Schema erlauben
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(baseUrl)) {
        throw new Error('Absolute URLs with scheme are not allowed');
    }
    // Keine protokoll-relativen URLs
    if (baseUrl.startsWith('//')) {
        throw new Error('Protocol-relative URLs are not allowed');
    }
    // Keine Backslashes (Windows-Pfad-Tricks)
    if (baseUrl.includes('\\')) {
        throw new Error('Backslashes are not allowed');
    }
    // Whitelist-Präfix prüfen
    const normalizedPath = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const isAllowed = ALLOWED_BASE_PATH_PREFIXES.some(prefix =>
        normalizedPath === prefix || normalizedPath.startsWith(prefix + '/')
    );
    if (!isAllowed) {
        throw new Error(`Base path '${baseUrl}' is not allowed`);
    }
};


export async function loadMessagesResponseItem(baseUrl: string, query: ViewerSearchQuery) : Promise<ViewerSearchQueryResult> {
    // validateBaseUrl(baseUrl);
    let url = getUrl(baseUrl, "api/viewer/search");
    let body = JSON.stringify(query, null, 2);
    let headers = { 
        "Accept": "application/json",
        "Content-Type": "application/json" 
    }
    let response = await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });
    return await response.json() as ViewerSearchQueryResult;    
}

export async function updateViewerLocationCollapseState(baseUrl: string, cmd: UpdateViewerLocationCollapseStateCommand) : Promise<void> {
    // validateBaseUrl(baseUrl); 
    let url = getUrl(baseUrl, "api/viewer/updateViewerLocationCollapseState");
    let body = JSON.stringify(cmd, null, 2);
    let headers = { 
        "Accept": "application/json",
        "Content-Type": "application/json" 
    }
    await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });    
}

export async function dismissViewerNewsItem(baseUrl: string, cmd: DismissViewerNewsItemCommand) : Promise<void> {
    // validateBaseUrl(baseUrl);
    let url = getUrl(baseUrl, "api/viewer/dismissViewerNewsItem");
    let body = JSON.stringify(cmd, null, 2);
    let headers = { 
        "Accept": "application/json",
        "Content-Type": "application/json" 
    }
    await fetch(url, { 
        method: "POST", 
        headers, 
        body
    });    
}

const getUrl = (baseUrl: string, path: string) : string => {
    return `${baseUrl}${baseUrl.endsWith("/") ? "" : "/"}${path}`;
}
